import apiClient from "../../apiClient";
import { CommonApiResponse } from "../../../Controllers/Types/ApiResponse";
import { baseURL } from "../../ApiConstant";

// get floor finishing list
export const getFSFloorFinishingList = async (fs_feature_id: number) => {
    try {
        const response = await apiClient.get(`/api/fs-floor-finishing-list/${fs_feature_id}`);

        if (response.status === 200) {
            return { status: true, body: response.data };
        } else {
            return { status: false, error: "failed" };
        }
    } catch (error: any) {
        console.error("Error fetching data:", error);

        return {
            status: false,
            error: "An error occurred. Please try again later.",
        };
    }
};